import jwtDecode from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { currencyToNumber } from "../../../../helpers/functions/currencyFormater";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import taService from "../services/ta.service";
import Collapse from "bootstrap/js/dist/collapse";

export default function useOnboardingView(active = {}) {
  const { Userdata = {}, id, taOnboardingCaseId } = active;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();

  const statusCodeBySHOrBA = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "All", value: "all" },
  ];
  const statusCodeByRISKORSA = [
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" },
  ];
  let option = [];

  if (
    user?.role === "Auction Representative" ||
    user?.role === "Business Analyst"
  ) {
    option = statusCodeBySHOrBA;
  } else if (
    user?.role === "Super Admin" ||
    user?.role === "Back Office HR" ||
    user?.role === "Developer" ||
    user?.role === "Head - Risk And Process"
  ) {
    option = statusCodeByRISKORSA;
  }

  // Default to "All" where the role has it (AR and BA). Pending hides every case
  // that reached limit setting, so a Limit Expiry filter applied on the default
  // queue would come back empty. Risk/SA have no "all" option — they keep
  // whichever queue their list starts with.
  const [statusCode, setStatusCode] = useState(
    option.find((o) => o.value === "all")?.value ?? option[0]?.value,
  );

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [userModal, setUserModal] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ID, setId] = useState();
  const [modalForUpdateLimit, setModalForUpdateLimit] = useState(false);
  const [modalAddComment, setModalAddComment] = useState(false);
  const [modalAddCommentData, setModalAddCommentData] = useState("");
  const [modalForUpdateLimitData, setModalForUpdateLimitData] = useState("");

  useEffect(() => {
    if (id) {
      setId(id);
    } else if (taOnboardingCaseId) {
      setId(taOnboardingCaseId);
    }
  }, [id, taOnboardingCaseId]);

  const handleVerifyAll = async (e, id, status) => {
    const auctionText = `You want to verify all`;
    Swal.fire({
      title: "Are you sure?",
      html: auctionText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verify All!",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const formData = new FormData();
        formData.append("taOnboardingCaseId", id);
        try {
          const response = await taService.VerifyCaseByBA(formData);
          if (response?.status === 200) {
            window.location.reload();
          } else {
            errorToast(response?.msg);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (user?.role === "Auction Representative") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUser(formData);

          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (user?.role === "Business Analyst") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserByBA(formData);
          if (response?.status === 200) {
            const updatedResponse = response?.data?.map((value) => ({
              ...value,
              ["stage"]: value?.isLimitSettingAllDocumentUploaded
                ? "Limit setting Email"
                : value?.isLosApplicationIdUpdated
                  ? "Limit setting Document Upload"
                  : value?.isCaseApprovedByBa
                    ? "LOS Updation"
                    : "Business Document Verification",
            }));
            setLoading(false);
            // setFilterData(response?.data);
            // setData(response?.data);
            setFilterData(updatedResponse);
            setData(updatedResponse);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (
          user?.role === "Super Admin" ||
          user?.role === "Developer" ||
          user?.role === "Back Office HR"
        ) {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserBySA(formData);
          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (user?.role === "Head - Risk And Process") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserByRisk(formData);
          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
        setLoading(false);
      }
    };

    fetchData();
  }, [statusCode]);

  const handleViewDetails = (val) => {
    if (
      val?.isCaseBusinessDetailsRejectedByBa &&
      user?.role === "Auction Representative"
    ) {
      history.push({
        pathname: `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${val?.taOnboardingCaseId}`,
        state: { value: val?.taOnboardingCaseId, data: val },
      });
    } else {
      history.push({
        pathname: `/auction_representative/user_home/manage-ta-onboard-id:${val?.taOnboardingCaseId}`,
        state: { value: val?.taOnboardingCaseId, data: val },
      });
    }
  };

  const handleSelectStatusCode = (e) => {
    setStatusCode(e.value);
  };

  const handleSendEmail = (value) => {
    const emailData = {
      to: "",
      cc: "",
      subject: `CF - KSOS - Limit Setting - ${value?.personName}`,
      body: `Hi,
      
      Please find attached new limit Setting documents for  ${value?.personName}.
      
      Pls confirm once limit setting done with details.
      
      Regards,
      Sachin`,
    };

    openOutlookEmail(emailData);
  };

  const openOutlookEmail = ({ to, cc, subject, body }) => {
    const mailtoLink = `mailto:${encodeURIComponent(
      to,
    )}?cc=${encodeURIComponent(cc)}&subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleConformEmail = async (value) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning", // Changed to warning for confirmation dialogs
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Mark as Sent!",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(), // Prevent closing while loading
        preConfirm: async () => {
          try {
            const formData = new FormData();
            formData.append("taOnboardingCaseId", value?.taOnboardingCaseId);
            const response = await taService.ConformMailsend(formData);

            if (response?.status === 200) {
              return response; // This will resolve Swal.fire with `result.value = response`
            } else {
              throw new Error(response?.msg || "Failed to send email");
            }
          } catch (err) {
            Swal.showValidationMessage(`Request failed: ${err.message}`);
            return false;
          }
        },
      });

      if (result.isConfirmed && result.value) {
        const response = result.value;
        successToast(response?.msg);
        await Swal.fire({
          title: "Email Sent!",
          text: "Email Marked as Sent Successfully!.",
          icon: "success",
        });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error sending confirmation email:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while sending the email.",
        icon: "error",
      });
    }
  };

  return {
    data,
    filterData,
    setFilterData,
    setData,
    modal,
    setModal,
    userModal,
    setUserModal,
    modalData,
    setModalData,
    loading,
    handleViewDetails,
    handleVerifyAll,
    option,
    handleSelectStatusCode,
    statusCode,
    setStatusCode,
    handleSendEmail,
    handleConformEmail,
    modalForUpdateLimit,
    setModalForUpdateLimit,
    modalAddComment,
    setModalAddComment,
    modalAddCommentData,
    setModalAddCommentData,
    modalForUpdateLimitData,
    setModalForUpdateLimitData,
  };
}
